import { render, staticRenderFns } from "./UserBasicInformation.vue?vue&type=template&id=07c07502"
import script from "./UserBasicInformation.vue?vue&type=script&lang=js"
export * from "./UserBasicInformation.vue?vue&type=script&lang=js"
import style0 from "./UserBasicInformation.vue?vue&type=style&index=0&id=07c07502&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports